import React, { Suspense } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { i18nTranslate } from "@didi/i18n-plugin";
import { i18nSetLang, i18nStart } from "@didi/i18n-plugin";
import { defaultLanguage, defaultLocale, CLIENT_TYPE, inApp, SOFI_TERMINAL_ID, SOFI_BRAND_NAME, MX_CITY_ID, SOFI_SDK_VERSION } from "@/common/js/constant";
import { setHeader, setParam } from "./utils/request";
import BasicLayout from "./components/Layout/BasicLayout";
import DownloadIcon from '@/assets/images/cycleSelection/download.png';
import "@/common/styles/reset.less";
import { init, setCity } from '@didi/elvish-lib-javascript';
import { initSign } from '@didi/wsgsig';
import {useRouterReadyTime} from "./utils/routeObserver";

// ========== 主包 =========== //
// 首页
// import SofiHome from "./views/SofiHome";
import SofiHome from "./views/Home";
// 欢迎页
// import PageWelcome from "./views/Welcome";
import { trackEvent } from "./utils/omega";

try {
    // 初始化elvish
    init("es_MX").then(() => setCity(MX_CITY_ID));
} catch (e) {
    // reset 墨西哥城市
    setCity(52151600);
    // 技术打点
    trackEvent("tech_sofi_catch_error", {
        source: 'app.elvish.init',
        data: JSON.stringify(e),
    });
}

const packageJson = require('../package.json');
// 初始化签名
try {
    initSign({
        env: 'ame', // 非必填；ame：美东环境；默认不填，为国内环境；
        bizId: '8d5bfc00c5a5af5552bc7e595fc5dd70',
        appVer: packageJson.version, // 业务方自定义，方便问题排查时定位版本tag（此处应该是变化的，随业务版本更新进行变化，便于定位问题）
        os: '4',  // 操作系统信息
    });
} catch (error) {
    console.error("初始化签名失败:", error);
}

// ========== 分包 =========== //
// 开户
const PageKYC = React.lazy(() => import("./views/KYC"));
// 客服
const CustomerService = React.lazy(() => import("./views/CustomerService"));
const CustomerServiceDetails = React.lazy(() => import("./views/CustomerServiceDetails"));
// 账户状态
const AccountStatus = React.lazy(() => import("./views/AccountStatus"));
// 冻结详情
const FreezeDetails = React.lazy(() => import("./views/FreezeDetails"));
// 入金
const Transfer = React.lazy(() => import("./views/Transfer"));
const SpeiPage = React.lazy(() => import("./views/Transfer/spei"));
// 简洁版本
const SpeiConcisePage = React.lazy(() => import("./views/Transfer/SpeiConcise"));
// 步骤版本
const SpeiProcessPage = React.lazy(() => import("./views/Transfer/SpeiProcess"));
// 出金
const TransferToClabe = React.lazy(() => import("./views/CashOut/transferToClabe"));
const CashOut = React.lazy(() => import("./views/CashOut"));
// 交易结果
const TransactionDetails = React.lazy(() => import("./views/TransactionDetails"));
// 账单详情
const BillDetails = React.lazy(() => import("./views/BillDetails"));
// 限制限额详情
const LimitDetails = React.lazy(() => import("./views/LimitDetails"));
// 交易记录
const Transaction = React.lazy(() => import("./views/Transaction"));
// 安全感知落地页
const SafePerception = React.lazy(() => import("./views/SafePerception"));
// 安全感知落地页
const PagePersonal = React.lazy(() => import("./views/Personal"));
// 个人信息页面
const PageProfile = React.lazy(() => import("./views/Personal/profile"));
// 统计周期选择页面
const CycleSelection = React.lazy(() => import("./views/CycleSelection"));
// 预览pdf
const PreviewPdf = React.lazy(() => import("./views/PreviewPdf"));
// 受益人首页/列表页
const Successor = React.lazy(() => import('./views/Successor'));
// 受益人表单页
const SuccessorAdd = React.lazy(() => import('./views/SuccessorAdd'));
// 已开sofipo户 不可didi充值 引导页
const SofipoOpenedTip = React.lazy(() => import('./views/SofipoOpenedTip'));

// 已开sofipo户 不可didi充值 引导页
const PageWaitingList = React.lazy(() => import('./views/WaitingList'));
// 已开sofipo户 不可didi充值 引导页
const PageWaitingListSuccess = React.lazy(() => import('./views/WaitingList/PageSuccess'));
// 消息中心退订页
const Unsubscribe = React.lazy(() => import('./views/Unsubscribe'));
// 限时加息活动详情页
const EventDetails = React.lazy(() => import('./views/EventDetails'));
// MGM
const MGMInvite = React.lazy(() => import("./views/MGM/M1/index"));
const MGMLanding = React.lazy(() => import("./views/MGM/M2/index"));
// MGM Rule Page
const MGMRule = React.lazy(() => import("./views/MGM/Rule/index"));
// MGM Ercode Page
const MGMErcode = React.lazy(() => import("./views/MGM/Ercode/index"));
// 活动规则详情页
const ActivityRuleDetails = React.lazy(() => import('./views/ActivityRuleDetails'));
// 券列表页
const CouponsList = React.lazy(() => import('./views/CouponsList'));
// 利率规则页面
const InterestRules = React.lazy(() => import('./views/Interest/rule'));
// 收益模拟页面
const ReturnsSimulation = React.lazy(() => import('./views/ReturnsSimulation'));
// 账户说明页面
const SafetyInstruction = React.lazy(() => import('./views/SafetyInstruction'));
// 税务信息上传页面
const TaxUpload  = React.lazy(() => import('./views/TaxInfo/upload'));
// 账单类型选择页面
const Statement = React.lazy(() => import('./views/Statement'));
// 预扣税账单选择页面
const AnnualTax = React.lazy(() => import('./views/AnnualTax'));

const TaxUploading = React.lazy(() => import('./views/TaxInfo/loading'));

const TaxInfo = React.lazy(() => import('./views/TaxInfo/info'));

const TaxFaq = React.lazy(() => import('./views/TaxInfo/faq'));

const TaxError = React.lazy(() => import('./views/TaxInfo/error'));

i18nStart(require("@/lang/i18n-index"), require("@/lang/i18n-info"));
// 设置i18n
i18nSetLang(defaultLanguage);

// 设置客户端类型
setParam("fromType", CLIENT_TYPE);

// 增加通用header didi-header-hint-content
setHeader('didi-header-hint-content', JSON.stringify({
    lang: defaultLanguage
}));

// 联调使用
// setParam("token", "Fld_3OvlFJWsDdHVb5SwJyGSK7NwZrqHTM-HzRy4RnY0zLGKwkAQgOF3-bnuhjCzk91J5h2uv1qNisUKilXIu0sE6w--la4kPuigCN1IE3ohi6q2IvSRtIgWtUSE0CvJ3z_CgbRR59HdQr1OJdzchRNp2oSFXHneX4_j8u024bx3bZqjfboLyW_d1ZpPZtp-atWCcCUxhBtZt3cAAAD__w==");


// 设置tmxjs 
// tmx设备指纹供应商0831试用期结束后处置：下线tmx设备指纹
// setParam("payrisk_info", JSON.stringify({ ln_session_id: "20230719" }));

// 设置wsgenv 改到拦截器里设置
// setParam("wsgenv", JSON.stringify({}));
// 设置locale
setParam("locale", defaultLocale.replace(/\-/g, "_"));
// 设置terminal ID
setParam("terminal_id", SOFI_TERMINAL_ID);
// 设置默认语言
setParam("lang", defaultLanguage);
// 设置默认城市
setParam("cityId", MX_CITY_ID);
// 设置端版本号
setParam("sofipo_sdk_version", SOFI_SDK_VERSION);

// URL 公参
if (window.location.search) {
    const params: URLSearchParams = new URLSearchParams(window.location.search);
    // 从URL参数中获取lat和lng
    setParam('lat', params.get('lat') || '');
    setParam('lng', params.get('lng') || '');

    // 如果存在idc标示，追加到所有请求上
    const idc: string | null = params.get('sofi_idc');
    if (idc) {
        setParam("sofi_idc", idc);
    }
}

// 端内获取token	
if (inApp && window.Fusion) {	
    // 设置token	
    try {	
        Fusion.loadModule("SofiBridgeModule").sfGetSofipoTicket((token: string) => {	
            setParam("token", token);	
            // setParam("token", "MfwSyMIO7b5a3eF27lP0zbpVtTLM4zxBaWJYPjTwnf00zDmKw0AQQNG7fCabQlR19TJdd5jcqRd5Sdpg40jo7kYGxw_ewlACn3RShGGECSMRSVVrEoYTKoxMWGtuvf_VLoxC8L9D2BMgHAjL2rO7NXVvXaslF05EU2EmFp731-M4f-9VOG9pLTn5J70Q_JZNrXorxeynFE0IVwJDuBG6vgMAAP__");	
        });	
    } catch (e) {	
        console.log("err");	
        // 技术打点	
        trackEvent("tech_sofi_catch_error", {	
            source: 'app.bridge.sfGetSofipoTicket',	
            data: JSON.stringify(e),	
        });	
    }	
}


// 公共路由path
const RouteBasename = process.env["BASE_PATH"] || "";
function AppContent() {
    useRouterReadyTime();
    return (
        <Routes>
                <Route
                    path="/"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<SofiHome />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/transfer"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<Transfer />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/spei"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<SpeiPage />} />
                        </Suspense>
                    }
                />
                {/* 简洁版本 */}
                <Route
                    path="/spei-concise"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<SpeiConcisePage />} />
                        </Suspense>
                    }
                />

                {/* 步骤版本 */}
                <Route
                    path="/spei-process"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<SpeiProcessPage />} />
                        </Suspense>
                    }
                />


                <Route
                    path="/limit"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<LimitDetails />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/billDetails"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} title={i18nTranslate("Fintech_Payment_Optimization_BIAB_lwdr")} bgColor="white" content={<BillDetails />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/details"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} title={i18nTranslate("Fintech_Payment_Optimization_bymF_byCA")} bgColor="white" content={<TransactionDetails />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/transaction"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} iconUrl={DownloadIcon} linkUrl={"/cycleSelection"} title={i18nTranslate("Fintech_Payment_AF_fXUE_ZcYk")} bgColor="white" content={<Transaction />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/cashout"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout title={i18nTranslate("Fintech_Payment_out_qfne_lRTR")} content={<CashOut />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/transfertoclabe"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout title={i18nTranslate("Fintech_Payment_out_qfne_lRTR")} content={<TransferToClabe />} />
                        </Suspense>
                    }
                />
                {/* <Route path="/welcome" element={<PageWelcome />} /> */}
                <Route
                    path="/freezeDetails"
                    element={
                        <Suspense fallback={<div></div>}>
                            <FreezeDetails />
                        </Suspense>
                    }
                />
                <Route
                    path="/customerService"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} title={i18nTranslate("Fintech_Payment_helpcenter_kDlf_knuA", { brand_name: SOFI_BRAND_NAME })} content={<CustomerService />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/customerServiceDetails"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} title={i18nTranslate("Fintech_Payment_helpcenter_jjmJ_itJL")} content={<CustomerServiceDetails />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/kyc"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout title="" content={<PageKYC />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/accountStatus"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout title="" content={<AccountStatus />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/safePerception"
                    element={
                        <Suspense fallback={<div></div>}>
                            <SafePerception />
                        </Suspense>
                    }
                />
                {/* 个人中心入口 */}
                <Route
                    path="/personal"
                    element={
                        <Suspense fallback={<div></div>}>
                            <PagePersonal />
                        </Suspense>
                    }
                />
                {/* 个人信息页面 */}
                <Route
                    path="/personal/profile"
                    element={
                        <Suspense fallback={<div></div>}>
                            <PageProfile />
                        </Suspense>
                    }
                />
                <Route
                    path="/cycleSelection"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} title={i18nTranslate("Fintech_Payment_Bankstatement_JpFH_XKLj")} content={<CycleSelection />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/previewPdf"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} title={i18nTranslate("Fintech_Payment_Bankstatement_cwrx_hynB")} content={<PreviewPdf />} />
                        </Suspense>
                    }
                />
                <Route path="/successor" element={
                    <Suspense fallback={<div></div>}>
                        <Successor />
                    </Suspense>
                } />
                {/* 新增受益人 */}
                <Route path="/successor/add" element={
                    <Suspense fallback={<div></div>}>
                        <SuccessorAdd />
                    </Suspense>
                } />
                {/* 编辑受益人 */}
                <Route path="/successor/add/:beneficiaryNo" element={
                    <Suspense fallback={<div></div>}>
                        <SuccessorAdd />
                    </Suspense>
                } />
                {/* 已开sofipo户情况下 点击didi充值 跳转的引导页 */}
                <Route path="/sofipoOpenedTip" element={
                    <Suspense fallback={<div></div>}>
                        <SofipoOpenedTip />
                    </Suspense>
                } />

                {/* 已开sofipo户情况下 点击didi充值 跳转的引导页 */}
                <Route path="/waiting-list" element={
                    <Suspense fallback={<div></div>}>
                        <PageWaitingList />
                    </Suspense>
                } />
                {/* 已开sofipo户情况下 点击didi充值 跳转的引导页 */}
                <Route path="/waiting-list-success" element={
                    <Suspense fallback={<div></div>}>
                        <PageWaitingListSuccess />
                    </Suspense>
                } />

                {/* 消息中心退订页面 */}
                <Route path="/messageUnsubscribe" element={
                    <Suspense fallback={<div></div>}>
                        <Unsubscribe />
                    </Suspense>
                } />

                {/* 限时加息活动详情页面 */}
                <Route path="/eventDetails" element={
                    <Suspense fallback={<div></div>}>
                        <EventDetails />
                    </Suspense>
                } />

                {/* MGM Invite Page */}
                <Route
                    path="/mgm/invite"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<MGMInvite />} />
                        </Suspense>
                    }
                />
                {/* MGM Landing Page */}
                <Route
                    path="/mgm/landing"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<MGMLanding />} />
                        </Suspense>
                    }
                />
                {/* MGM Rule Page */}
                <Route
                    path="/mgm/rules"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<MGMRule />} />
                        </Suspense>
                    }
                />
                {/* MGM Ercode Page */}
                <Route
                    path="/mgm/ercode"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<MGMErcode />} />
                        </Suspense>
                    }
                />
                {/* 活动规则详情页 */}
                <Route path="/activityRuleDetails" element={
                    <Suspense fallback={<div></div>}>
                        <ActivityRuleDetails />
                    </Suspense>
                } />

                {/* 券列表页 */}
                <Route path="/coupons" element={
                    <Suspense fallback={<div></div>}>
                        <CouponsList />
                    </Suspense>
                } />
                {/** 利率规则页面 */}
                <Route
                    path="/interest-rules"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<InterestRules />} />
                        </Suspense>
                    }
                />
                {/** 收益模拟页面 */}
                <Route
                    path="/returns-simulation"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<ReturnsSimulation />} />
                        </Suspense>
                    }
                />     
                 {/** 账户说明页面 */}
                <Route
                    path="/safety-instruction"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<SafetyInstruction />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/tax/upload"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<TaxUpload />} />
                        </Suspense>
                    }
                />  
                <Route
                    path="/tax/loading"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<TaxUploading />} />
                        </Suspense>
                    }
                />    
                <Route
                    path="/tax/info"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<TaxInfo />} />
                        </Suspense>
                    }
                /> 
                <Route
                    path="/tax/faq"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<TaxFaq />} />
                        </Suspense>
                    }
                />
                <Route
                    path="/tax/error"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={true} content={<TaxError />} />
                        </Suspense>
                    }
                />    

                 {/** 账单类型选择页面 */}
                <Route
                    path="/statement"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} content={<Statement />} />
                        </Suspense>
                    }
                />
                 {/** 预扣税账单选择页面 */}
                <Route
                    path="/statement/annual-tax"
                    element={
                        <Suspense fallback={<div></div>}>
                            <BasicLayout hideHeader={inApp} content={<AnnualTax />} />
                        </Suspense>
                    }
                />
            </Routes>
    )
}

export default function App() {
    // useRouterReadyTime();
    return (
        <BrowserRouter basename={RouteBasename}>
            <AppContent />           
        </BrowserRouter>
    );
}
